import { render, staticRenderFns } from "./AdvantageCreate.vue?vue&type=template&id=fe068dd6&"
import script from "./AdvantageCreate.vue?vue&type=script&lang=js&"
export * from "./AdvantageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports